module.exports = __webpack_public_path__ + "images/912899bd76fe3ff4f1c5e3654e1c7e48.svg";